import { DataCenterPromoCard } from "@/components/pricing-promos/src/data-center-promo-card.tsx";
import { TwcPromo } from "@/components/pricing-promos/src/twc-promo.tsx";
import { PricingFeatureTable } from "@/components/wpl/pricing/src/features-table/features-table";
import {
    usePricingContentContext,
    useDatacenterPlans
} from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { PricingFaq } from "@/components/wpl/pricing/src/pricing-faq/pricing-faq";
import { QuotationsAdornment } from "@/components/wpl/pricing/src/pricing-faq/quotations";
import { PageHeading } from "@/components/wpl/pricing/src/pricing-page-layout/page-heading";
import { PricingPageLayout } from "@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout";
import { QuestionsCta } from "@/components/wpl/pricing/src/questions-cta";
import { AppPricingData } from "@/contentful/product-catalog";
import ConfluenceSoftwareNav from "@/templates/software/confluence/confluence-software-page/src/sections/confluence-navbar.tsx";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { ParentScrollTracking } from "@/utils/scroll-tracking/parent-scroll-tracker.tsx";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import ConfluencePriceFinder from "./sections/confluence-price-finder.tsx";

export type ConfluencePricingPageV2TemplateProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
};

// eslint-disable-next-line complexity
export const ConfluencePricingPageV2Template = (
    props: ConfluencePricingPageV2TemplateProps
    // eslint-disable-next-line complexity
) => {
    const content = usePricingContentContext();

    const featuresCtaContent = content
        ?.callToActionContainer?.[1] as CallToAction;
    const dataCenterContent = useDatacenterPlans("Contact Us", "Learn more");
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;

    return (
        <PricingPageLayout
            nav={<ConfluenceSoftwareNav />}
            showFallback={content?.hasError}
        >
            <ParentScrollTracking
                scrollTrackingEnabled={true}
                pageId="confluence-pricing-page"
            >
                <PageHeading>{content?.headline}</PageHeading>
                <ConfluencePriceFinder
                    pricing={props.pricing}
                    countryCode={props.countryCode}
                />
                <PricingFeatureTable
                    title={content?.compareFeaturesTitle ?? undefined}
                    comparePlans={content?.comparePlans ?? undefined}
                    compareFeatures={content?.compareFeatures ?? undefined}
                    linkValues={{
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    }}
                    dataProductKey={"confluence"}
                />
                <DataCenterPromoCard dataCenterContent={dataCenterContent} />
                <TwcPromo product="confluence" />
                <QuotationsAdornment>
                    <ParentScrollTracking>
                        <PricingFaq
                            header={content?.getMoreDetailsTitle ?? undefined}
                            planDetails={
                                content?.additionalDetails ?? undefined
                            }
                        />
                    </ParentScrollTracking>
                </QuotationsAdornment>
                <QuestionsCta
                    product={"Confluence"}
                    ctaHref={questionsCtaContent?.url ?? undefined}
                    questionsHeader={questionsCtaContent?.title ?? undefined}
                    priceAndLicensingLinkText={
                        questionsCtaContent?.text ?? undefined
                    }
                    questionsBody={
                        questionsCtaContent?.valueProposition ?? undefined
                    }
                    imageHref={questionsCtaContent?.asset?.url}
                />
            </ParentScrollTracking>
        </PricingPageLayout>
    );
};
